import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AgeVerification from './components/AgeVerification';
import CookieConsent from './components/CookieConsent';
import SEO from './components/SEO';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Guides from './pages/Guides';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import Reviews from './pages/Reviews';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import Cookies from './pages/Cookies';
import ResponsibleGaming from './pages/ResponsibleGaming';
import CommentParierEnLigneFrance from './pages/guides/CommentParierEnLigneFrance';
import ChoisirMeilleurSiteParis from './pages/guides/ChoisirMeilleurSiteParis';
import ComprendreBonusBienvenue from './pages/guides/ComprendreBonusBienvenue';
import StrategiesParisSportifs from './pages/guides/StrategiesParisSportifs';
import GererBankrollEfficacement from './pages/guides/GererBankrollEfficacement';
import TypesParisDifferents from './pages/guides/TypesParisDifferents';
import SecuriteReglementation from './pages/guides/SecuriteReglementation';
import RetirerGainsRapidement from './pages/guides/RetirerGainsRapidement';
import ParierDirectConseils from './pages/guides/ParierDirectConseils';
import NouvellesReglementationsAnj2025 from './pages/news/NouvellesReglementationsAnj2025';
import TendancesParisSportifs20252026 from './pages/news/TendancesParisSportifs20252026';
import OperateursAmeliorentExperienceMobile from './pages/news/OperateursAmeliorentExperienceMobile';
import BonusBienvenueEvolution2025 from './pages/news/BonusBienvenueEvolution2025';
import SecuriteDonneesParisEnLigne from './pages/news/SecuriteDonneesParisEnLigne';
import CroissanceParisEsportFrance from './pages/news/CroissanceParisEsportFrance';
import StrategiesParieursProfessionnels from './pages/news/StrategiesParieursProfessionnels';
import ImpactIntelligenceArtificielleParis from './pages/news/ImpactIntelligenceArtificielleParis';
import RetraitsRapidesNouvellesTechnologies from './pages/news/RetraitsRapidesNouvellesTechnologies';
import Circusbet from './pages/reviews/Circusbet';
import Bwin from './pages/reviews/Bwin';
import Betsson from './pages/reviews/Betsson';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <SEO />
      <AgeVerification />
      <CookieConsent />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/guides" element={<Guides />} />
        <Route path="/guides/comment-parier-en-ligne-france" element={<CommentParierEnLigneFrance />} />
        <Route path="/guides/choisir-meilleur-site-paris" element={<ChoisirMeilleurSiteParis />} />
        <Route path="/guides/comprendre-bonus-bienvenue" element={<ComprendreBonusBienvenue />} />
        <Route path="/guides/strategies-paris-sportifs" element={<StrategiesParisSportifs />} />
        <Route path="/guides/gerer-bankroll-efficacement" element={<GererBankrollEfficacement />} />
        <Route path="/guides/types-paris-differents" element={<TypesParisDifferents />} />
        <Route path="/guides/securite-reglementation" element={<SecuriteReglementation />} />
        <Route path="/guides/retirer-gains-rapidement" element={<RetirerGainsRapidement />} />
        <Route path="/guides/parier-direct-conseils" element={<ParierDirectConseils />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/nouvelles-reglementations-anj-2025" element={<NouvellesReglementationsAnj2025 />} />
        <Route path="/news/tendances-paris-sportifs-2025-2026" element={<TendancesParisSportifs20252026 />} />
        <Route path="/news/operateurs-ameliorent-experience-mobile" element={<OperateursAmeliorentExperienceMobile />} />
        <Route path="/news/bonus-bienvenue-evolution-2025" element={<BonusBienvenueEvolution2025 />} />
        <Route path="/news/securite-donnees-paris-en-ligne" element={<SecuriteDonneesParisEnLigne />} />
        <Route path="/news/croissance-paris-esport-france" element={<CroissanceParisEsportFrance />} />
        <Route path="/news/strategies-parieurs-professionnels" element={<StrategiesParieursProfessionnels />} />
        <Route path="/news/impact-intelligence-artificielle-paris" element={<ImpactIntelligenceArtificielleParis />} />
        <Route path="/news/retraits-rapides-nouvelles-technologies" element={<RetraitsRapidesNouvellesTechnologies />} />
        <Route path="/news/:id" element={<NewsDetail />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/reviews/circusbet" element={<Circusbet />} />
        <Route path="/reviews/bwin" element={<Bwin />} />
        <Route path="/reviews/betsson" element={<Betsson />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/responsible-gaming" element={<ResponsibleGaming />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;
